export default __webpack_public_path__ + "static/media/uploadEn1.fdf0a57d.jpg";